import React from "react";
import { Spin, Alert as AlertAntd, Typography } from "antd";
import AlertDialog from "./AlertDialog";
import { ReactComponent as MosquitoIconSvg } from "../../assets/icons/MosquitoVector.svg";
import { DetectionStatusData } from "../../types/components/home";

import "./index.css";

const { Title, Text } = Typography;

type Props = {
  loading: boolean;
  isFetchingMore: boolean;
  joinedAlerts: DetectionStatusData[];
  onAlertClick: (id: string) => void;
  onScroll: React.UIEventHandler<HTMLDivElement>;
};

const DetectionActivity: React.FC<Props> = ({
  loading,
  isFetchingMore,
  joinedAlerts,
  onAlertClick,
  onScroll,
}) => {
  return (
    <div className="detection-box-container">
      <Spin spinning={loading}>
        <div className="detection-box-title">
          <Title level={4} className="detection-box-title-text">
            Mosquito Detections
          </Title>
        </div>
        <div
          className={`detection-box-alerts force-show-scrollbars ${
            joinedAlerts.length > 0 ? "has-alerts" : "no-alerts"
          }`}
          onScroll={onScroll}
        >
          {joinedAlerts.length > 0 ? (
            <>
              {joinedAlerts.map((item: DetectionStatusData) => (
                <AlertDialog
                  key={item._id}
                  item={item}
                  onClick={onAlertClick}
                />
              ))}
              {isFetchingMore && (
                <div className="flex justify-center p-4">
                  <Spin size="small" />
                </div>
              )}
            </>
          ) : (
            !loading && (
              <AlertAntd
                message={<Text strong>No detections</Text>}
                showIcon
                type="success"
                icon={
                  <MosquitoIconSvg
                    width={24}
                    height={24}
                    stroke="none"
                    fill="#22C55E"
                  />
                }
              />
            )
          )}
        </div>
      </Spin>
    </div>
  );
};

export { DetectionActivity };
